module.exports = __webpack_public_path__ + "img/ic_materials.eb62e1f6.svg";